import { useNavigate } from "react-router-dom";
import { FETCH_LIST_ITEMS as fetchListItems } from "../../../../../../graphql/query/ListItems";
import {
  SelectList,
  multiSelect,
} from "../../../../../../components/Functional";
import ExportImages from "./ExportImages";
import { LIST_TYPES } from "../../../../../../constants/listTypes";

const Actions = props => {
  const { formik, imageListId, imageWorkingListId } = props || {};
  const navigate = useNavigate();
  const listId = imageListId || imageWorkingListId;
  const sourceTypeId = imageListId
    ? LIST_TYPES.INSTANCE_IMAGE
    : LIST_TYPES.INSTANCE_IMAGE_WORKING;
  const ids = Object.keys(formik?.values?.selectedImages?.ids || {})?.map(
    item => parseInt(item.replace("_", "")),
  );

  return (
    <div className="grid grid-flow-col gap-4">
      <SelectList.RemoveSelected {...props} ids={ids} listId={listId} />
      <SelectList.ClearList {...props} listId={listId} />
      <SelectList.CopyList
        {...props}
        listId={imageListId || imageWorkingListId}
        typeId={sourceTypeId}
        sourceTypeId={sourceTypeId}
        onSuccess={() => (
          props?.onSuccess?.(),
          navigate("/instance?status=selectListWorking")
        )}
      />
      <ExportImages {...props} ids={ids} listId={listId} />
      {imageListId ? (
        <SelectList.ExitEditMode
          onSuccess={() => (
            props?.onSuccess?.(),
            navigate("/instance?status=imageSelectListSaved")
          )}
        />
      ) : (
        <SelectList.SaveList
          {...{
            ...props,
            typeId: LIST_TYPES.INSTANCE_IMAGE,
            onSuccess: () => (
              props?.onSuccess?.(),
              navigate("/instance?status=imageSelectListSaved")
            ),
            workingListId: imageWorkingListId,
          }}
        />
      )}
    </div>
  );
};

const tableProps = props => {
  const { imageListId, imageWorkingListId, formik } = props || {};

  const multiSelectProps = {
    formik,
    label: "Instances",
    name: "selectedImages",
    keyName: "id",
  };

  const tableProps = {
    dataKey: "listItems",
    fetchPolicy: "network-only",
    FETCH_QUERY: fetchListItems({
      item: { artwork: { title: true, artists: {} }, imgT: true },
    }),
    headers: [
      multiSelect(multiSelectProps),
      { label: "Artwork Image", name: "item.imgT", type: "image" },
      { label: "Artwork Name", name: "item.artwork.title", type: "label" },
      {
        label: "Artist Name",
        name: "item.artwork.artists[0].name",
        type: "label",
      },
    ],
    skip: values => !values?.listId,
    variables: {
      // use working list if no listId is provided
      listId: imageListId || imageWorkingListId,
    },
  };

  return tableProps;
};

export { Actions, tableProps };
